module.exports = __webpack_public_path__ + "img/icon-wallet-red.7bff12b7.svg";